"use client"

import rightArrow from "assets/img/right-arrow.webp";
import leftArrow from "assets/img/left-arrow.webp";
import downArrow from "assets/img/down-arrow.webp"
import {useEffect, useState} from "react";


export default function CardValuePropDivider(props) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 768);
    }, []);

    function getArrow() {
        if (isMobile) {
            return downArrow;
        }
        return index % 2 ? rightArrow : leftArrow
    }

    const {index, len} = props
    if (index > len - 2) {
        return null
    }

    const arrow = getArrow()
    return <div className="d-flex justify-content-center align-items-center">
        <img src={arrow.src} style={{height: 110}} alt="value section divider"/>
    </div>
}
